import { render, staticRenderFns } from "./SmartSummary.vue?vue&type=template&id=6681a343&scoped=true"
import script from "./SmartSummary.vue?vue&type=script&lang=js"
export * from "./SmartSummary.vue?vue&type=script&lang=js"
import style0 from "./SmartSummary.vue?vue&type=style&index=0&id=6681a343&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6681a343",
  null
  
)

export default component.exports